import { render, staticRenderFns } from "./BookingAuj.vue?vue&type=template&id=2dd2c654&scoped=true&"
import script from "./BookingAuj.vue?vue&type=script&lang=js&"
export * from "./BookingAuj.vue?vue&type=script&lang=js&"
import style0 from "./BookingAuj.vue?vue&type=style&index=0&id=2dd2c654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd2c654",
  null
  
)

export default component.exports